import UseFetch from "../../hook/useFetch";
import { List } from '@mui/material';
import { useMemo } from "react";
import "./style.css";
import slugify from "../../Utils/slugify";
function CustomList(props) {
  const { data } = UseFetch(
    "https://ebuy-backend-two.vercel.app/api/article"
  );

  const produits = useMemo(() => Array.from(data), [data]);

  const filteredData = produits
    .filter((el) => {
      const searchInput = props.input.toLowerCase().trim();

      if (searchInput.length < 2) return false;

      return (
        el.articleName?.toLowerCase().includes(searchInput) ||
        el.brand?.toLowerCase().includes(searchInput) ||
        el.ref?.toLowerCase().includes(searchInput) ||
        el.categorie?.toLowerCase().includes(searchInput) ||
        el.famille?.toLowerCase().includes(searchInput)
      );
    })
    .slice(0, 8);

  // ✅ AJOUTER ICI
  const getProductLink = (item) => {
    if (!item.subcategorie) {
      return `/produit/${slugify(item.famille)}/${slugify(item.categorie)}/${slugify(item.articleName)}`;
    }

    if (item.subSubcategorie) {
      return `/produit/${slugify(item.famille)}/${slugify(item.categorie)}/${slugify(item.subcategorie)}/${slugify(item.subSubcategorie)}/${slugify(item.articleName)}`;
    }

    return `/produit/${slugify(item.famille)}/${slugify(item.categorie)}/${slugify(item.subcategorie)}/${slugify(item.articleName)}`;
  };

  const getProductImage = (item) => {
    if (!item.subcategorie) {
      return `https://firebasestorage.googleapis.com/v0/b/ebuy-10d2e.appspot.com/o/${encodeURIComponent(item.famille)}%2F${encodeURIComponent(item.categorie)}%2F${item.article.replace(/-/g, " ")}.jpeg?alt=media`;
    }

    if (item.subSubcategorie) {
      return `https://firebasestorage.googleapis.com/v0/b/ebuy-10d2e.appspot.com/o/${encodeURIComponent(item.famille)}%2F${encodeURIComponent(item.categorie)}%2F${encodeURIComponent(item.subcategorie)}%2F${encodeURIComponent(item.subSubcategorie)}%2F${item.article.replace(/-/g, " ")}.jpeg?alt=media`;
    }

    return `https://firebasestorage.googleapis.com/v0/b/ebuy-10d2e.appspot.com/o/${encodeURIComponent(item.famille)}%2F${encodeURIComponent(item.categorie)}%2F${encodeURIComponent(item.subcategorie)}%2F${item.article.replace(/-/g, " ")}.jpeg?alt=media`;
  };
    

   return (
  <div className="listOfArticle">
    {props.input.length >= 2 && (
      <List
        sx={{
          width: "100%",
          bgcolor: "background.paper",
          position: "relative",
          overflow: "auto",
          maxHeight: 400,
        }}
      >
      {filteredData.map((item) => (
  <a
    className="listLink"
    href={getProductLink(item)}
    key={item.id}
  >
    <h3 className="liArticle">
      <img
        src={getProductImage(item)}
        alt="produit"
        className="prodPicList"
      />

      <div className="listDetails">
        <span>
          {item.articleName} - {item.brand}
        </span>

        {item.prixFlash > 0 ? (
          <span style={{ color: "#F77171" }}>
            {item.prixFlash} TND
          </span>
        ) : item.prixPromo > 0 ? (
          <span style={{ color: "#F77171" }}>
            {item.prixPromo} TND

            <span
              style={{
                color: "#283943",
                marginLeft: "10px",
              }}
            >
              PROMO!
            </span>
          </span>
        ) : (
          <span style={{ color: "#F77171" }}>
            {item.prix} TND
          </span>
        )}
      </div>
    </h3>
  </a>
))}

{/* BUTTON SHOW ALL */}
<a
  href={`/search?query=${props.input}`}
  className="showAllResultsBtn"
>
  Voir tous les résultats
  <span>→</span>
</a>
      </List>
    )}
  </div>
);
}

export default CustomList;
